import { useState } from 'react';
import { Media, Container, Nav, NavItem, NavLink,
        TabPane, TabContent 
    } from 'reactstrap';
import '../../index.css';
import '../../App.css';
import { Link, useParams } from 'react-router-dom';
import { getEquipByName } from '../../shared/equipInfo';
import classnames from 'classnames';
import EquipStats from './EquipStats';
import EquipLore from './EquipLore';
import BackToList from '../BackToList';
import SkeletonImage from '../SkeletonImage';
import TagChips from '../tags/TagChips';

const EquipDetails = () =>{
    return (
        <Container className="gs-page">
            <div className="gs-page-gutter">
                <EquipHome />
            </div>
        </Container>
    )
}

const EquipHome = () => {
    //Equip Info
    const selectedEquip = useParams(); //Find Equip name based on parameters
    const decodedEquipName = decodeURIComponent(selectedEquip.equipName)
    const equips = getEquipByName(decodedEquipName);
    

    //Tabs for Equip Lore and Stats
    const [currentTab, setCurrentTab] = useState("1");
    const toggle = tab => {
        if (currentTab !== tab) setCurrentTab(tab);
    }

    if (!equips) {
        return (
            <>
                <BackToList to="/equips" label="Back to Equips" />
                <div className="gs-empty-state gs-empty-state--inline" role="status">
                    <h2>Equipment not found</h2>
                    <p>No equipment named “{decodedEquipName}” exists in the database.</p>
                    <div className="gs-empty-state__actions">
                        <Link to="/equips" className="gs-btn">Browse Equips</Link>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <BackToList to="/equips" label="Back to Equips" />
            <header className="gs-page-intro">
                <h1>{equips.name}</h1>
                <p>Select a category to view equipment information</p>
            </header>
            <div className="gs-equip-detail">
                <Nav pills justified className="gs-tabs">
                    <NavItem>
                        <NavLink
                            className={classnames({ active: currentTab === '1' })}
                            onClick={() => { toggle('1') }}
                        >
                            <span style={{ userSelect: "none" }}>Stats</span>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: currentTab === '2' })}
                            onClick={() => { toggle('2') }}
                        >
                            <span style={{ userSelect: "none" }}>Lore</span>
                        </NavLink>
                    </NavItem>
                </Nav>

                <RenderImage
                    name={equips.name}
                    thumb={equips.image.thumb}
                    thumbmax={equips.image.thumbmax}
                    detail={equips.image.detail}
                    detailmax={equips.image.detailmax}
                />
                <RenderName name={equips.name} type={equips.type} location={equips.location} />

                <TabContent activeTab={currentTab}>
                    <TabPane tabId="1">
                        <TagChips tags={equips.tags} />
                        <EquipStats skillset={equips.skillset} stats={equips.stats} passive={equips.passive} star={equips.star} />
                    </TabPane>
                    <TabPane tabId="2">
                        <EquipLore lore={equips.lore} />
                    </TabPane>
                </TabContent>
            </div>
        </>
    )
}

const RenderImage = ({ name, thumb, thumbmax, detail, detailmax }) => {
    //Tabs
    const [currentTab, setCurrentTab] = useState("2");
    const toggle = tab => {
        if (currentTab !== tab) setCurrentTab(tab);
    }

    if (!thumb) {
        return (
            <div className="gs-unit-detail-art">
                <SkeletonImage
                    src={detailmax}
                    alt={name}
                    className="gs-unit-detail-art__img"
                    frameClassName="gs-skeleton-frame--detail"
                />
            </div>
        );
    }

    return (
        <>
            <Nav pills className="gs-tabs gs-tabs--thumbs gs-tabs--compact">
                <NavItem>
                    <NavLink
                        className={classnames({ active: currentTab === '1' })}
                        onClick={() => { toggle('1') }}
                    >
                        <SkeletonImage
                            src={thumb}
                            alt={`${name} thumbnail`}
                            frameClassName="gs-skeleton-frame--detail-thumb"
                            loading="lazy"
                        />
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        className={classnames({ active: currentTab === '2' })}
                        onClick={() => { toggle('2') }}
                    >
                        <SkeletonImage
                            src={thumbmax}
                            alt={`${name} max limit break thumbnail`}
                            frameClassName="gs-skeleton-frame--detail-thumb"
                            loading="lazy"
                        />
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={currentTab}>
                <TabPane tabId="1">
                    <div className="gs-unit-detail-art">
                        <SkeletonImage
                            src={detail}
                            alt={name}
                            className="gs-unit-detail-art__img"
                            frameClassName="gs-skeleton-frame--detail"
                        />
                    </div>
                </TabPane>
                <TabPane tabId="2">
                    <div className="gs-unit-detail-art">
                        <SkeletonImage
                            src={detailmax}
                            alt={`${name} (Max Limit Break)`}
                            className="gs-unit-detail-art__img"
                            frameClassName="gs-skeleton-frame--detail"
                        />
                    </div>
                </TabPane>
            </TabContent>
        </>
    )
}

const RenderName = ({ type, name, location }) => {
    return (
        <div className="gs-equip-detail__name">
            <h1>
                <Media src={type} alt="" />
                <span>{name}</span>
                <Media src={type} alt="" />
            </h1>
            {location ? (
                <p className="gs-unit-detail__meta"><i>{location}</i></p>
            ) : null}
        </div>
    )
}

export default EquipDetails;
